import { SimulationHqDataColumn } from '@warebee/shared/dataset-queries';
import { TFunction } from 'i18next';
import { FilterFieldConfig } from '../../common/types';
import i18n from '../../i18n';
import { getAssignmentFilterConfigDefault } from '../assignment/assignmentFilterConfigDefault';
import { getItemSetFilterConfigDefault } from '../itemSet/itemSetFilterConfigDefault';
import { getItemStatsFilterConfigDefault } from '../itemStats/itemStatsFilterConfigDefault';
import { getLocationFilterConfigDefault } from '../location/locationFilterConfigDefault';

export function getSimulationHqFilterConfigDefault(
  t: TFunction<'app'> = i18n.t,
): FilterFieldConfig<SimulationHqDataColumn>[] {
  return [
    ...getItemSetFilterConfigDefault(t),
    ...getItemStatsFilterConfigDefault(t),
    ...getAssignmentFilterConfigDefault(t),
    ...getLocationFilterConfigDefault(t),
  ];
}
